import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { once } from 'lodash';
import getLocale from 'src/js/modules/i18n/selectors/locale';
import user from 'src/js/modules/user';
import sites from 'src/js/modules/sites';
import analytics from 'src/js/modules/analytics';
import { AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG, APP_NAME } from '../../constants/common';
import useFeatureFlags from '../../modules/feature-flags/hooks/use-feature-flags';

const callAppOpenedOnce = once((siteId, templateBuildSlug) => {
  analytics.segment.track(analytics.segment.eventTypes.APP_OPENED, {
    appName: APP_NAME,
    siteId,
    templateBuildSlug,
  });
});

const Main = ({
  router,
  locale = null,
  siteIdRecreate = null,
  siteIdToSwitchTemplate = null,
  templateBuildSlug = null,
  isUserAuthenticated = false,
}) => {
  const [, , requestedFeatureFlags] = useFeatureFlags([AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG]);

  // Used in order to save sequence for APP_OPENED and PLATFORM_SELECTOR_DISPLAYED
  // which is triggered inside useEffect hook of PlatformSelectorContainer
  useLayoutEffect(() => {
    if (locale && isUserAuthenticated) {
      const siteId = siteIdRecreate || siteIdToSwitchTemplate || null;

      callAppOpenedOnce(siteId, templateBuildSlug);
    }
  }, [locale, isUserAuthenticated, siteIdRecreate, siteIdToSwitchTemplate, templateBuildSlug]);

  const isRequitedFlagsLoaded = requestedFeatureFlags.includes(
    AI_OPTIONAL_TEMPLATE_SELECTION_STEP_FLAG
  );

  if (!locale || (isUserAuthenticated && !isRequitedFlagsLoaded)) return null;

  return <RouterProvider router={router} />;
};

Main.propTypes = {
  router: PropTypes.object.isRequired,
  locale: PropTypes.string,
  siteIdRecreate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  siteIdToSwitchTemplate: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  templateBuildSlug: PropTypes.string,
  isUserAuthenticated: PropTypes.bool,
};

const mapStateToProps = (state) => {
  const locale = getLocale(state);
  const siteIdRecreate = sites.selectors.getSiteIdRecreate(state);
  const siteIdToSwitchTemplate = sites.selectors.getSiteIdToSwitchTemplate(state);
  const templateBuildSlug = sites.selectors.getTemplateBuildSlug(state);
  const isUserAuthenticated = user.selectors.getUserAuthorizationStatus(state);

  return {
    locale,
    isUserAuthenticated,
    siteIdRecreate,
    siteIdToSwitchTemplate,
    templateBuildSlug,
  };
};

export default connect(mapStateToProps, null)(Main);
